export default __webpack_public_path__ + "static/media/36I-102797_-15961_0.29bfd232.jpg";